<template>
  <div id="address" v-if="showWindow">
    <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :filters="filters"
      >
    </table-view>
  </div>
</template>

<script>

import tableView from '../../components/tableView';
export default {
  components: {   
    tableView
  },
  data() {
    
    let data = {
      params:{},
      endPoint:'addresses',
      filters: {
        brokers: true,
        status: true
      }
    }
    data.columnDefs= JSON.parse(localStorage.getItem('addressColumns'))
    /*const eurFields = ['initial_amount','amount_approved'];
    const btcFields = ['initial_value','value_approved'];
    for(let i in data.columnDefs){
      if(eurFields.indexOf(data.columnDefs[i].field)!==-1)
        data.columnDefs[i].valueFormatter = params => currencyFormatter(params.value, ' EUR');
      else if(btcFields.indexOf(data.columnDefs[i].field)!==-1)
        data.columnDefs[i].valueFormatter = params => currencyFormatter(params.value, ' BTC');
    }*/
    return data;
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/addresses'){
        return true;
      }
      return false;
    },
  },
  mounted() {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
  }
}
/*function isNumeric(str) {
  if (typeof str != "string") return true // we only process strings!
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
function currencyFormatter(currency, sign) {
  if(currency===undefined || !isNumeric(currency))
    return null;
  console.log('currency',currency);
  var sansDec = currency.toFixed(0);
  var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return sign + `${formatted}`;
}*/
</script>
